import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import OperatorApplicationDialog from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialog.vue";
import {Intervals} from "~/ts/library/delay/Intervals";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {computed, onMounted, watch} from "vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import DateHelper from "~/ts/library/Date";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";


const __default__ = {
    name: "OperatorApplicationDialogForCabinetReports"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    username: {},
    dialogId: {}
  },
  setup(__props: any) {

let props = __props;

let buddyList: OperatorApplicationApi.OperatorBuddyListConfigOpenApiModel = {
    id: "cabinetReports",
    descr: "",
    icon: "",
    isSystem: true,
    isMainBuddyList: false,
    isOnlineClientsList: false,
    isAnotherOperatorBuddyList: false,
    isCustomSearchList: false,
    isCrossOperatorsChat: false,
    orderConfig: [],
    externalBuddyListSearchFiltersLink: null
};

function sendNotification() {
    let p: OperatorApplicationApi.OperatorBuddyListCabinetIframeKeepAliveOpenApiModel = {
        username: props.username
    };
    (new OperatorApiRequest({
        url: "/buddyList/cabinetIframeKeepAlive",
        p,
        silent: true,
        silentError: true
    })).send();
}

let timeZone = computed(() => {
    let userdata = ClientUserdataStore.getByUsername(props.username, false);
    if (userdata) {
        let site = OperatorAccountStore.sitesDictionary.value[userdata.siteId];
        if (site) {
            return site.timeZone;
        }
    }
    return 0;
});

watch(timeZone, () => {
    DateHelper.setTimeZoneOffset(timeZone.value * 3600);
}, {
    immediate: true
});

watch(computed(() => props.username), sendNotification, {
    immediate: true
});

addDisposableEvent(Intervals.setDisposable(sendNotification, 30000));

onMounted(() => {
    if (props.dialogId) {
        OperatorApplicationBuddyList.scrollToDialogId(props.username, props.dialogId);
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OperatorApplicationDialog, {
    username: __props.username,
    "buddy-list": _unref(buddyList),
    class: "w-100"
  }, null, 8, ["username", "buddy-list"]))
}
}

})